import {
  AgentsSubscriptionAmountHardLimitError,
  AuthenticationError,
  AuthorizationError,
  NetworkError,
} from '@back4app2/sdk';

export type HandleMessageErrorsResult =
  | { redirectToLogin: true }
  | { redirectToLogin?: false; message: string; showUpgradePlanLink?: boolean };

export function handleMessageErrors(e: unknown): HandleMessageErrorsResult {
  if (e instanceof NetworkError) {
    return {
      message:
        'Network error when creating agent. Check your internet connection and try again.',
    };
  }

  if (e instanceof AuthenticationError || e instanceof AuthorizationError) {
    return { redirectToLogin: true };
  }

  if (e instanceof AgentsSubscriptionAmountHardLimitError) {
    return {
      message: 'You have reached the maximum number of agents.',
      showUpgradePlanLink: false,
    };
  }

  const msg = (e as any)?.message;
  return {
    message: msg || 'Unexpected error when creating agent. Please try again.',
  };
}

